export const desktopScreenWidth = 768;

export const sideMenuWidth = "18rem";
